import angular from 'angular';
import validFile from './valid-file.directive';

export default angular
  .module('verifyApp.valid-file', [])
  .directive('validFile', validFile)
  .name;



// WEBPACK FOOTER //
// ./client/components/valid-file/index.js